import { useIsEmeaCountry } from '../../../../common/hooks/useIsEmeaCountry';
import { OfferingType } from '../../../../graphql';

type Props = Readonly<{
  countryCode: string;
}>;

export const useGetCountryExcludedTypes = ({ countryCode }: Props): OfferingType[] => {
  const { isEmea } = useIsEmeaCountry(countryCode);

  return isEmea ? [OfferingType.OvernightFo, OfferingType.UnregisteredBlock] : [OfferingType.Abb];
};
